import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _omit from 'lodash/omit';

import MESSAGES from 'constants/messages';

import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';

export const isUnique = (features, name) => {
  const names = _map(features, feature => feature.name);

  const featureNames = _filter(names, (value, index, i) =>
    _includes(i, value, index + 1),
  );

  return !featureNames.includes(name);
};

export const validate = values => {
  const errors = {};
  const featuresError = [];

  if (!values.name || stringIsInvalid(values.name)) {
    errors.name = MESSAGES.ENTITIES.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(values.name)) {
    errors.name = MESSAGES.ENTITIES.NAME.MAX_LENGTH;
  }

  _forEach(values.features, (feature, featureIndex) => {
    featuresError[featureIndex] = {};

    if (!feature.name) {
      featuresError[featureIndex].name = MESSAGES.FEATURES.NAME.REQUIRED;
    } else {
      if (stringIsInvalid(feature.name)) {
        featuresError[featureIndex].name = MESSAGES.FEATURES.NAME.REGEX;
      }

      if (!isUnique(values.features, feature.name)) {
        featuresError[featureIndex].name = MESSAGES.FEATURES.NAME.UNIQUE;
      }
    }

    if (!feature.feature_type) {
      // FIXME: Do not use underscore
      featuresError[featureIndex].feature_type = MESSAGES.FEATURES.TYPE;
    }
  });

  errors.features = featuresError;
  return errors;
};

export const constructFeaturesToSave = features => {
  const multiFeatures = {
    update: {},
    create: [],
    delete: [],
  };

  _forEach(features, feature => {
    if (feature.id && feature.name !== 'value') {
      multiFeatures.update[feature.id] = feature;
    }

    if (!feature.id) {
      multiFeatures.create = [
        ...multiFeatures.create,
        {
          ...feature,
          public: Boolean(feature.public),
          archived: Boolean(feature.archived),
        },
      ];
    }
  });

  multiFeatures.delete = features.reduce((acc, feature) => {
    if (feature.archived) {
      return [...acc, feature.id];
    }

    return acc;
  }, []);

  multiFeatures.update = _omit(multiFeatures.update, multiFeatures.delete);

  return multiFeatures;
};
